import styled from 'styled-components';
import PrimaryButton from '@carvana/showroom-forms/Button/Primary';

const ModalContentWrapper = styled.div`
  font-family: ${(props) => props.theme.font.family};
  background: #fff;
  padding: 25px;
  display: flex;
  flex-direction: column;
  align-items: center;
  @media (min-width: ${(props) => props.theme.breakpoint.lg}px) {
    padding: 40px 80px 60px;
  }
`;

const Description = styled.div`
  font-weight: ${(props) => props.theme.font.weight.v300};
  ${(props) => props.theme.font.heading.v100};
  color: ${(props) => props.theme.color.primary.v600};
  padding: 15px 0 30px;
  text-align: center;
  text-transform: uppercase;
  width: 300px;
  line-height: 24px;
  @media (min-width: ${(props) => props.theme.breakpoint.lg}px) {
    width: 450px;
  }
`;

const DetailsRow = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding-bottom: 8px;
  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    flex-direction: row;
  }
`;

const DetailsRowWithAmount = styled(DetailsRow)`
  padding-bottom: 35px;
`;

const DetailHighlight = styled.span`
  ${(props) => props.theme.font.label.v300};
  color: ${(props) => props.theme.color.primary.v600};
  font-weight: ${(props) => props.theme.font.weight.v300};
  padding: 0 5px;
`;

const ConfirmButton = styled(PrimaryButton)`
  width: 330px;
  height: 55px;
  color: ${(props) => props.theme.color.neutral.v100};
  text-transform: uppercase;
  margin-bottom: 100%;
  text-align: center;
  @media (min-width: ${(props) => props.theme.breakpoint.sm}px) {
    width: 360px;
  }
  @media (min-width: ${(props) => props.theme.breakpoint.lg}px) {
    width: 250px;
    margin-bottom: 0;
  }
`;

export {
  ModalContentWrapper,
  Description,
  DetailsRow,
  DetailHighlight,
  ConfirmButton,
  DetailsRowWithAmount,
};
